import { GlobalPageLoadExperience } from '@atlassian/ufo';
import DatabaseLayout from '@databases/layout/DatabaseLayout';
import {
  Database,
  BrokenDatabase,
  DatabaseField,
  EntryCreateOptions,
  EntryWithContext,
} from '@databases/types/database';
import React, { FunctionComponent, useEffect, useLayoutEffect, useState } from 'react';

import {
  DatabasePreview,
  DatabasePreviewComponentProps,
} from '../databasePreview/DatabasePreview';
import EmbedReferenceOptions from '../embedReferenceOptions/EmbedReferenceOptions';

export interface EmbedReferenceProps {
  ToolbarComponent: React.FunctionComponent<{
    contentId: string;
    actions: any;
    canEditFields: boolean;
    canEditContent: boolean;
    showViewSettings?: boolean;
  }>;
  DatabasePreviewComponent: React.FunctionComponent<DatabasePreviewComponentProps>;
  EntryPreviewComponent: React.FunctionComponent<{
    contentId: string;
    entryId: string;
  }>;
  ValuePreviewComponent: React.FunctionComponent<{
    contentId: string;
    entryId: string;
    fieldId: string;
  }>;
}

export const cancelDatabaseReference = () => {
  window.parent.postMessage(
    JSON.stringify({ cancelDatabaseReference: true }),
    window.location.origin
  );
};

const EmbedReference: FunctionComponent<EmbedReferenceProps> = ({
  ToolbarComponent,
  DatabasePreviewComponent,
  EntryPreviewComponent,
  ValuePreviewComponent,
}) => {
  const [selectedDatabase, setSelectedDatabase] = useState<
    Database | BrokenDatabase | undefined
  >(undefined);
  const [selectedEntry, setSelectedEntry] = useState<
    EntryWithContext | EntryCreateOptions | undefined
  >(undefined);
  const [selectedField, setSelectedField] = useState<DatabaseField | undefined>(
    undefined
  );
  const [databaseError, setDatabaseError] = useState(false);

  const isBrokenDatabase = (
    database: Database | BrokenDatabase | undefined
  ): database is BrokenDatabase => {
    if (database) {
      return 'error' in database;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setDatabaseError(isBrokenDatabase(selectedDatabase));
  }, [selectedDatabase]);

  useLayoutEffect(() => {
    window.parent.postMessage(
      JSON.stringify({ databaseReferencingComponentLoaded: true }),
      window.location.origin
    );
  }, []);

  GlobalPageLoadExperience.success({ force: true });

  return (
    <DatabaseLayout
      options={{ toolbarLocation: 'views' }}
      view={
        <DatabasePreview
          databaseError={databaseError}
          selectedDatabase={selectedDatabase}
          selectedEntry={selectedEntry}
          selectedField={selectedField?.id}
          DatabasePreviewComponent={DatabasePreviewComponent}
          EntryPreviewComponent={EntryPreviewComponent}
          ValuePreviewComponent={ValuePreviewComponent}
        />
      }
      sidebar={
        <EmbedReferenceOptions
          setSelectedDatabase={setSelectedDatabase}
          selectedDatabase={selectedDatabase}
          setSelectedEntry={setSelectedEntry}
          selectedEntry={selectedEntry}
          setSelectedField={setSelectedField}
          selectedField={selectedField}
          databaseError={databaseError}
        />
      }
      toolbar={
        selectedDatabase && !selectedEntry && !selectedField ? (
          <ToolbarComponent
            contentId={selectedDatabase.contentId}
            canEditContent={false}
            canEditFields={false}
            actions={[]}
            showViewSettings={false}
          />
        ) : null
      }
    />
  );
};
export default EmbedReference;
